import React, { FunctionComponent, Fragment, useContext } from "react";
import { observer } from "mobx-react";
import { Grid, Typography } from "@material-ui/core";
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import TranslatedNode from "../../../ui/TranslatedNode/TranslatedNode";
import UITranslations from "../../../../store/uiTranslations";
import { Context } from "../../../../store/context";
import _ from "lodash";

interface IParkChoiceItem {}

const ParkingChoiceItem: FunctionComponent<IParkChoiceItem> = () => {
  const ui = UITranslations.GettingToPage.Wizard.Parking;

  const { gettingToPageStore } = useContext(Context);

  const hasAlternativeParking =
    gettingToPageStore.settings?.alternativeParkingId !== undefined &&
    gettingToPageStore.settings?.alternativeParkingId > 0;

  return (
    <Fragment>
      <Typography>
        <TranslatedText source={ui.ParkAt} />{" "}
        <strong>
          <TranslatedNode
            id={gettingToPageStore.settings?.preferredParkingId}
          />
        </strong>
        {"."}
      </Typography>
      {hasAlternativeParking && (
        <Typography gutterBottom>
          {"("}
          <TranslatedText source={ui.SecondChoice} />
          <TranslatedNode
            id={gettingToPageStore.settings?.alternativeParkingId}
          />
          {")"}
        </Typography>
      )}
    </Fragment>
  );
};

export default observer(ParkingChoiceItem);
